export type StepId = 'select-file' | 'preview-upload' | 'confirm';

export const STEPS = [
  { id: 'select-file', label: 'Select File', bodyTag: 'csv-import-setup-body' },
  {
    id: 'preview-upload',
    label: 'Preview Upload',
    bodyTag: 'csv-import-review-body',
  },
  {
    id: 'confirm',
    label: 'Confirm Import',
    bodyTag: 'csv-import-confirm-body',
  },
] as const satisfies ReadonlyArray<{
  id: StepId;
  label: string;
  bodyTag: string;
}>;

/**
 * Converts a StepId to the 1-based index expected by `inmar-hc-stepper`.
 */
export function stepIndex(id: StepId): number {
  return STEPS.findIndex((s) => s.id === id) + 1;
}
